export default () => {
  const active_grid = document.querySelector('[data-change-grid].active');
  let tiles_per_row = active_grid?.dataset.perRow ? Number(active_grid.dataset.perRow) : 5;

  // We don't have the layout change on the search results page
  if (typeof tiles_per_row === 'undefined' || isNaN(tiles_per_row)) {
    tiles_per_row = 5;
  }

  if (window.theme.breakpoints.current === 'mobile') {
    tiles_per_row = 2;
  }

  // console.log(`tiles_per_row ${tiles_per_row}`);

  $('[data-product-tile-title]').removeAttr('style');

  /*
  // The following code works when product tiles per row are consistent, which is not our case since we can have marking blocks of different sizes
  let title_height = 0;
  // let price_height = 0;
  let $row = null;
  let max_height = 0;

  _.each($('.grid .product-tile'), (tile, index) => {
    if (index % tiles_per_row === 0) {
      // Rarely used functions below, it takes n and (n + 2) elements
      $row = $(tile).nextAll(`.product-tile:lt(${tiles_per_row - 1})`).addBack();

      max_height = 0;
      _.each($row, (row_tile) => {
        // Price can now be on 2 lines, height can be greater than the title if compare at is active
        title_height = $(row_tile).find('[data-product-tile-title]').height();
        // price_height = $(row_tile).find('[data-product-tile-price]').height();

        if (title_height > max_height) {
          max_height = title_height;
        }

        // if (price_height > max_height) {
        //   max_height = price_height;
        // }
      });

      // console.log(max_height, `Row starting with ${$(tile).data('product-handle')}`);

      $row.find('[data-product-tile-title]').height(max_height);
   }
  });
  */

  let total_per_row = 0; // count the number of tiles on the current row
  let max_title_height = 0;
  let tiles_in_row = [];
  let current_row = 1;

  _.each($('.grid > div'), (item, index) => {
    let ignore_item = false;

    // It's possible we get a few other div elements in it, we just ignore them
    const item_type = item.classList.contains('product-tile') ? 'product_tile' : 
                      item.classList.contains('plp-mb') ? 'marketing_block' : '';

    if (item_type === '') {
      ignore_item = true;
    }

    if ((window.theme.breakpoints.current === 'mobile' && item.classList.contains('hidden--mobile')) || (window.theme.breakpoints.current !== 'mobile' && item.classList.contains('hidden--desktop'))) {
      ignore_item = true;
    }

    if (!ignore_item) {
      // We reached the end of the row
      if (total_per_row === tiles_per_row) {
        // console.log(`tiles_in_row: `, tiles_in_row);
        // console.log('max_title_height', max_title_height);
  
        // Assign the same height to all product tiles in row
        tiles_in_row.forEach(tile => {
          const title_el = tile.querySelector('[data-product-tile-title]');
          if (title_el) {
            // console.log('current_row', current_row, 'max_title_height', max_title_height);
            title_el.style.height = `${max_title_height}px`;
          }
        });
  
        total_per_row = 0;
        max_title_height = 0;
        tiles_in_row = [];
        current_row++;
      }
  
      if (item_type === 'product_tile') {
        total_per_row++;
        const title_el = item.querySelector('[data-product-tile-title]');
        const tile_title_height = title_el?.querySelector('a')?.offsetHeight || 0;

        max_title_height = (tile_title_height > max_title_height) ? tile_title_height : max_title_height;
        tiles_in_row.push(item);
      } else if (item_type === 'marketing_block') {
        switch (item.dataset.format) {
          case 'tile':
            total_per_row++;
            break;
  
          // We used to have 4 tiles per row
          case 'half':
            total_per_row += 2;
            break;
  
          case 'full':
            total_per_row += tiles_per_row;
            break;

          default:
            break;
        }
      }
    }
  });

  // Assign the same height to all product tiles in last row
  tiles_in_row.forEach(tile => {
    const title_el = tile.querySelector('[data-product-tile-title]');
    if (title_el) {
      title_el.style.height = `${max_title_height}px`;
    }
  });

  tiles_in_row = [];
};
